<!--
 * @Author: shiao
 * @Date: 2021-01-30 16:05:38
 * @LastEditTime: 2021-02-01 15:10:25
 * @Description: 
 * @LastEditors: shiao
 * @FilePath: \o2o-appd:\gongsi\h5-hotel\h5\src\pages\hotel\components\no-room.vue
-->
<template>
  <div>
    <div class="noroom-icon"><img :src="noroomicon" alt="" /></div>
    <div class="noroom-text">暂时没有更多房型哦～</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      noroomicon: require("@/assets/hotel/img/micon/404.png"),
    };
  },
};
</script>

<style lang="less" scoped>
.noroom-icon {
  width: 20rem;
  height: 20rem;
  margin: 3rem auto;
  img {
    width: 100%;
    height: 100%;
  }
}
.noroom-text {
  text-align: center;
  height: 2.4rem;
  font-size: 1.7rem;
  font-weight: 400;
  color: #666666;
  line-height: 2.4rem;
  margin: 0 auto 3rem;
}
</style>